(function () {
  const el = document.getElementById('ws_shipping-date');
  if (!el) return;

  const date = new Date();

  // Normalize time to avoid timezone edge cases
  date.setHours(12, 0, 0, 0);

  // Always move to next day
  date.setDate(date.getDate() + 1);

  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  el.textContent = `${weekdays[date.getDay()]}. ${months[date.getMonth()]} ${date.getDate()}`;
})();
